<p-toast key="reports"></p-toast>



<p-dialog header="Prenos dokumentov"  [(visible)]="showFilesDialog" showEffect="fade" [modal]="true" [style]="{minWidth: '400', width:'600px'}">
	
	<div *ngIf="(canUpload)">
		<p-panel header="NALAGANJE DOKUMENTOV" [toggleable]="false">
		
			<label>Izberi tip datokeke, ki jo želiš naložiti</label>
			<p-select (onChange)="onBeforeUploadFile($event)" [style]="{'width':'100%'}" [options]="docTypes" [(ngModel)]="selectedDocType" ></p-select>
			
			<p-fileUpload  (onSelect)="onBeforeUploadFile($event)" (onBeforeUpload)="onBeforeUploadFile($event)" (onUpload)="onUploadFile($event)" chooseLabel="Izberi dat." uploadLabel="Naloži" cancelLabel="Prekliči" name="file" [url]="uploadurl" >
			
			</p-fileUpload>
		</p-panel>
	</div>

	
	<p-panel header="PREGLED DOKUMENTOV" [toggleable]="false" [style]="{'margin-top':'20px'}">
	
		<p-tabs>
		<!-- 
		<div style="width:400px" class="p-grid p-grid-responsive p-fluid"  *ngFor="let item of downloadFilesList let i=index">
	        <div class="p-grid-row">
	            <div style="border-bottom:1px solid black; padding: 3px"><a href="{{item.url}}">{{item.fileName}}</a></div>
	           
	        </div>
	    </div>
	     -->
	     <div  *ngIf="(canDownload)"> 
	     
	     
	       
	     <p-tabPanel *ngFor="let item of downloadFilesListFilteredKeys let i=index" [header]="item" className="tPanel"   [closable]="false"   >
	     	{{downloadFilesListFilteredKeys[item]}}
	     	<!-- 
	     	<div *ngFor="let dat of downloadFilesListFiltered[item]" style="border-bottom:1px solid black; padding: 3px"><a href="{{dat.url}}">{{dat.fileName}}</a></div>
	     	 -->
	     	 <div *ngFor="let dat of downloadFilesListFiltered[item]" [style]="{borderBottom:'1px solid black',cursor:'pointer',height: '3px'}">
	     	 <div [style]="{float:'left',padding: '5px'}" (click)="downloadFile(dat.url)">{{dat.fileName}}</div>
	     	 <div [style]="{float:'left',padding: '5px', color:'red', fontWeight: 'bold'}" (click)="deleteFile(dat.urlDelete)">Briši datoteko</div>
	     	 
	     	 </div>
	     </p-tabPanel>
	    </div>
	   
	   	
	    <div [style]="{width:'50%', height:'30px'}" class="p-grid-row" *ngIf="(noFiles)">
	            <div class="p-grid-col-9"><label for="vin">Ni datotek</label></div>
	    </div>
		</p-tabs>
	</p-panel>
</p-dialog>

<p-dialog
  header="PRIPRAVA POROČILA"
  [(visible)]="displayreports"
  [style]="{width:'800px', height:'620px'}"
  styleClass="reports-dialog"
  [baseZIndex]="30000"
>
 

 <div class="container">

  <div class="row">
    
    <div class="col col-s1">
    	<div class="row rdtitle"><div class="col">UVOD</div></div>
     	<div class="row">
     		<div class="col">  <p-checkbox name="groupname" value="ch1_zakonodajneZahteve" [(ngModel)]="selectedValuesReport"></p-checkbox> </div><div class="col-10">Zakonodajne zahteve</div>
     	</div>
     	<div class="row">
     		<div class="col"> <p-checkbox name="groupname" value="ch1_metodeDela" [(ngModel)]="selectedValuesReport"></p-checkbox>  </div><div class="col-10">Metode dela</div>
     	</div>
     	<hr>
     <div class="row rdtitle"><div class="col">ZNAČILNOSTI OBČINE POMEMBNE Z VIDIKA ENERGETIKE</div></div>
     	
     	<div class="row">
     		<div class="col">  <p-checkbox name="groupname" value="ch1_splosneZnacilnosti" [(ngModel)]="selectedValuesReport"></p-checkbox>  </div><div class="col-10" >Splošne značilnosti</div>
     	</div>
     	<div class="row">
     		<div class="col"> <p-checkbox name="groupname" value="ch1_prebivalstvoInPoselitev" [(ngModel)]="selectedValuesReport"></p-checkbox>   </div><div class="col-10" >Prebivalstvo in poselitev</div>
     	</div>
     	<div class="row">
     		<div class="col"> <p-checkbox name="groupname" value="ch1_stavbniFond" [(ngModel)]="selectedValuesReport"></p-checkbox>   </div><div class="col-10">Stavbni fond</div>
     	</div>
     	
     	<div class="row">
     		<div class="col"> <p-checkbox name="groupname" value="ch1_maleKurilneNaprave" [(ngModel)]="selectedValuesReport"></p-checkbox>  </div> <div class="col-10">Male kurilne naprave </div>
     		
     		<!-- 
     		<div class="col-2"><i class="pi pi-file" style="cursor: pointer" aria-hidden="true" (click)="showHtml('kurilne_naprave_vrsta_goriva');"></i> </div>
     		 -->
     	</div>
     	<div class="row">
     		<div class="col">  <p-checkbox name="groupname" value="ch1_klimaInPodnebje" [(ngModel)]="selectedValuesReport"></p-checkbox>  </div><div class="col-10" >Klima in podnebje</div>
     	</div>
     	<div class="row">
     		<div class="col">  <p-checkbox name="groupname" value="ch1_varovanaObmocja" [(ngModel)]="selectedValuesReport"></p-checkbox>  </div><div class="col-10" >Varovana območja</div>
     	</div>
     		<hr>
     <div class="row rdtitle"><div class="col">ANALIZA RABE ENERGIJE IN ENERGENTOV PO POSAMEZNIH PODROČJIH IN ZA OBČINO KOT CELOTO</div></div>
     	
     	<div class="row">
     		<div class="col">  <p-checkbox name="groupname" value="ch2_rabaEnergijeVStanovanjskemSektorju" [(ngModel)]="selectedValuesReport"></p-checkbox>  </div><div class="col-10">Raba energije v stanovanjskem sektorju</div>
     	</div>
     	<div class="row">
     		<div class="col"> <p-checkbox name="groupname" value="grupaREJ" (onChange)="checkMultiple('grupaREJ','grupaREJ',['ch2_obcinskeStavbe','ch2_stavbeDrzavnihOrganov','ch2_javnaRazsvetljava'])" [(ngModel)]="selectedValuesReport"></p-checkbox>   </div><div class="col-10">Raba energije v javnem sektorju</div>
     	</div>
     	<div class="row">
     		<div class="col"> <p-checkbox name="groupname" value="ch2_obcinskeStavbe" (onChange)="checkMultiple('grupaREJ','ch2_obcinskeStavbe',['ch2_obcinskeStavbe','ch2_stavbeDrzavnihOrganov','ch2_javnaRazsvetljava'])"  [(ngModel)]="selectedValuesReport"></p-checkbox>  </div><div class="col-10">&nbsp;&nbsp;Občinske stavbe</div>
     	</div>
     	
     	<div class="row">
     		<div class="col"> <p-checkbox name="groupname" value="ch2_stavbeDrzavnihOrganov" (onChange)="checkMultiple('grupaREJ','ch2_stavbeDrzavnihOrganov',['ch2_obcinskeStavbe','ch2_stavbeDrzavnihOrganov','ch2_javnaRazsvetljava'])" [(ngModel)]="selectedValuesReport"></p-checkbox>   </div><div class="col-10">&nbsp;&nbsp;Stavbe državnih organov</div>
     	</div>
     	
     	<div class="row">
     		<div class="col"> <p-checkbox name="groupname" value="ch2_javnaRazsvetljava" (onChange)="checkMultiple('grupaREJ','ch2_javnaRazsvetljava',['ch2_obcinskeStavbe','ch2_stavbeDrzavnihOrganov','ch2_javnaRazsvetljava'])" [(ngModel)]="selectedValuesReport"></p-checkbox>   </div><div class="col-10">&nbsp;&nbsp;Javna razsvetljava</div>
     	</div>
     	
     	<div class="row">
     		<div class="col"> <p-checkbox name="groupname" value="ch2_rabaEnergijeVIndustriji" [(ngModel)]="selectedValuesReport"></p-checkbox>   </div><div class="col-10">Raba energije v poslovnem sektorju</div>
     	</div>
     	
     	<div class="row">
     		<div class="col"> <p-checkbox name="groupname" value="ch2_rabaEnergijeVPrometu" [(ngModel)]="selectedValuesReport"></p-checkbox>   </div><div class="col-10">Raba energije v prometu</div>
     	</div>
     	
     	<div class="row">
     		<div class="col"> <p-checkbox name="groupname" value="ch2_rabaElektricneEnergije" [(ngModel)]="selectedValuesReport"></p-checkbox>   </div><div class="col-10">Raba električne energije</div>
     	</div>
     	
     	<div class="row">
     		<div class="col">  <p-checkbox name="groupname" value="ch2_skupnaRabaEnergije" [(ngModel)]="selectedValuesReport"></p-checkbox>  </div><div class="col-10">Skupna raba energije v občini</div>
     	</div>
   
	</div>
     
   
    <div class="col col-s2">
    
		<div class="row rdtitle"><div class="col">ANALIZA OSKRBE Z ENERGIJO</div></div>
     	
     	<div class="row">
     		<div class="col"> <p-checkbox name="groupname" value="ch3_skupneKotlovnice" [(ngModel)]="selectedValuesReport"></p-checkbox>   </div><div class="col-10">Skupne kotlovnice</div>
     	</div>
     	<div class="row">
     		<div class="col"> <p-checkbox name="groupname" value="ch3_daljinskoOgrevanje" [(ngModel)]="selectedValuesReport"></p-checkbox>  </div><div class="col-10">Daljinsko ogrevanje</div>
     	</div>
     	<div class="row">
     		<div class="col"> <p-checkbox name="groupname" value="ch3_oskrbaZElektricnoEnergijo" [(ngModel)]="selectedValuesReport"></p-checkbox>   </div><div class="col-10">Oskrba z električno energijo</div>
     	</div>
     	<div class="row">
     		<div class="col"> <p-checkbox name="groupname" value="ch3_oskrbaZZemeljskimPlinomInUNP" [(ngModel)]="selectedValuesReport"></p-checkbox>   </div><div class="col-10">Oskrba z zemeljskim plinom in UNP</div>
     	</div>

		<hr>
    	
     	<div class="row rdtitle"><div class="col">ANALIZA EMISIJ</div></div>
     	<div class="row">
     		<div class="col">  <p-checkbox name="groupname" value="ch4_analizaEmisij" [(ngModel)]="selectedValuesReport"></p-checkbox>  </div><div class="col-10">Analiza emisij</div>
     	</div>

    	<hr>

     	<div class="row rdtitle"><div class="col">ANALIZA POTENCIALOV OVE</div></div>
     	<div class="row">
     		<div class="col">  <p-checkbox name="groupname" value="ch5_potencialBiomase" [(ngModel)]="selectedValuesReport"></p-checkbox>  </div><div class="col-10">Biomasa</div>
     	</div>
     	<div class="row">
     		<div class="col">  <p-checkbox name="groupname" value="ch5_potencialBioplina" [(ngModel)]="selectedValuesReport"></p-checkbox>  </div><div class="col-10">Bioplin</div>
     	</div>
     	<div class="row">
     		<div class="col">  <p-checkbox name="groupname" value="ch5_potencialSonca" [(ngModel)]="selectedValuesReport"></p-checkbox>  </div><div class="col-10">Sonce</div>
     	</div>
     	<div class="row">
     		<div class="col">  <p-checkbox name="groupname" value="ch5_potencialGeotermalne" [(ngModel)]="selectedValuesReport"></p-checkbox>  </div><div class="col-10">Geotermija</div>
     	</div>
     	<div class="row">
     		<div class="col">  <p-checkbox name="groupname" value="ch5_potencialVetra" [(ngModel)]="selectedValuesReport"></p-checkbox>  </div><div class="col-10">Veter</div>
     	</div>
     	<div class="row">
     		<div class="col">  <p-checkbox name="groupname" value="ch5_potencialVode" [(ngModel)]="selectedValuesReport"></p-checkbox>  </div><div class="col-10">Voda</div>
     	</div>

     	<!-- <hr>
     	<div class="row rdtitle"><div class="col">ŠIBKE TOČKE</div></div>
     	<div class="row">
     		<div class="col">  <p-checkbox name="groupname" value="ch6_sibkeTocke" [(ngModel)]="selectedValuesReport"></p-checkbox>  </div><div class="col-10">Šibke točke</div>
     	</div>
     	
     	<hr>
     	<div class="row rdtitle"><div class="col">AKCIJSKI NAČRT</div></div>
     	<div class="row">
     		<div class="col">  <p-checkbox name="groupname" value="ch7_nacrtUkrepov" [(ngModel)]="selectedValuesReport"></p-checkbox>  </div><div class="col-10">Načrt ukrepov</div>
     	</div>
     	<div class="row">
     		<div class="col">  <p-checkbox name="groupname" value="ch7_posebniCilji" [(ngModel)]="selectedValuesReport"></p-checkbox>  </div><div class="col-10">Posebni cilji</div>
     	</div>
     	<hr>
     	<div class="row rdtitle"><div class="col">DOKUMENTACIJA</div></div>
  
     	<div class="row">
     		<div class="col">  <p-checkbox name="groupname" value="val1" [(ngModel)]="selectedValuesReport"></p-checkbox> </div><div class="col-10">LEK</div>
     	</div>
     	<div class="row">
     		<div class="col">  <p-checkbox name="groupname" value="val1" [(ngModel)]="selectedValuesReport"></p-checkbox>  </div><div class="col-10">Povzetek LEK</div>
     	</div>

     	<div class="row">
     		<div class="col"> <i (click)="showUploadForm()" style="cursor:pointer" class="pi pi-upload"></i> </div><div class="col-10">Obrazec letnega poročila</div>
     	</div> -->
     
    </div>
  
  
  </div>
  

  
  
</div>


  
  <ng-template pTemplate="footer">
    <div class="row rdfooter">
      <div class="col btn rdfooter">GENERIRAJ POROČILO</div>
      <div class="col btn" (click)="exportReport('xls')">EXCEL</div>
      <div class="col btn" (click)="exportReport('docx')">WORD</div>
      <div class="col btn" (click)="exportReport('pdf')">PDF</div>
    </div>
  </ng-template>
  
</p-dialog>